import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { FollowUsOnFacebook } from "scmp-sdk/components/follow-us-on-facebook";
import type { ThemeType } from "scmp-sdk/components/newsletter/newsletter-widget/types";

import { fontMerriweather, fontRoboto, theme as mediaTheme } from "shared/lib/styles";

import IconTickCircle from "./icon-tick-circle.svg";

export const StyledIconTickCircle = styled(IconTickCircle)``;

type TitleProps = {
  theme?: ThemeType;
};
export const Title = styled.div<TitleProps>`
  grid-area: Title;

  font-weight: 700;
  font-size: 20px;
  font-family: ${fontMerriweather};
  line-height: 25px;

  ${props => {
    if (props.theme?.signUpSuccess?.titleFontStyle === "small") {
      return css`
        font-size: 16px;
        line-height: 20px;
      `;
    }
  }}
`;

export const IconContainer = styled.div`
  grid-area: Icon;

  inline-size: 25px;
  block-size: 25px;
  margin-block-end: 8px;
`;

export const StyledFollowUsOnFacebook = styled(FollowUsOnFacebook)`
  margin-block-start: 24px;

  text-align: start;
`;

type CheckEmailMessageProps = {
  theme?: ThemeType;
};

export const CheckEmailMessage = styled.div<CheckEmailMessageProps>`
  grid-area: CheckEmail;

  margin-block-end: 8px;
  padding-block-start: 12px;

  color: #000000;
  font-size: 14px;
  font-family: ${fontMerriweather};
  line-height: 18px;

  ${props => {
    if (props.theme?.signUpSuccess?.checkEmailMessageStyle === "gray") {
      return css`
        color: #a1a1a1;
      `;
    }
    if (props.theme?.signUpSuccess?.checkEmailMessageStyle === "white") {
      return css`
        color: #ffffff;
      `;
    }
  }}
`;

export const SeeMoreLink = styled.a`
  grid-area: SeeMoreLink;

  font-size: 14px;
  font-family: ${fontRoboto};
  line-height: 18px;
  text-decoration: underline;

  cursor: pointer;
`;

export const Footer = styled.div`
  grid-area: Footer;

  display: grid;
  grid-template-areas:
    "CheckEmail"
    "SeeMoreLink"
    "FollowOnFacebook";

  ${mediaTheme.breakpoints.up("mediumDesktop")} {
    border-color: #eeeeee;
  }

  ${SeeMoreLink} {
    color: #4585ff;
  }
`;

export const Container = styled.div`
  display: grid;
  grid-template-areas:
    "Icon"
    "Title"
    "Footer";
  grid-template-columns: 1fr;
  grid-column-gap: 12px;
  justify-items: center;

  color: #001246;
  text-align: center;
`;
